import React, { useState } from "react";
import { Link } from "react-router-dom";
import {useAuth} from "../../contexts/AuthContext"
import "./navbar.css";
import App from "../Auth/Auth"; // 引入用于登录/注册的组件（可能为模态框）
import { MdOutlineTravelExplore } from "react-icons/md";
import { AiFillCloseCircle } from "react-icons/ai";
import { TbGridDots } from "react-icons/tb";

const Navbar = () => {
  // 用于控制导航栏的显示状态（默认为隐藏状态，适用于响应式菜单）
  const [active, setActive] = useState("navBar");
  // 用于控制登录/注册组件的显示状态
  const [openAuth, setOpenAuth] = useState(false);
  // 从 AuthContext 中获取当前用户和登出方法
  const { currentUser, logout } = useAuth();

  // 显示导航栏（例如点击菜单图标时）
  const showNav = () => {
    setActive("navBar activeNavbar");
  };

  // 隐藏导航栏（例如点击关闭图标时）
  const removeNavbar = () => {
    setActive("navBar");
  };

  // 处理登出操作
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("登出失败:", error);
    }
  };

  return (
    <section className="navBarSection">
      {/* 顶部导航栏区域 */}
      <header className="header flex">
        {/* Logo部分 */}
        <div className="logoDiv">
          <a href="#" className="logo flex">
            <h4>
              <MdOutlineTravelExplore className="icon" />
              &nbsp;&nbsp;&nbsp;交 流 開 啟 你 的 未 來
            </h4>
          </a>
        </div>

        {/* 导航菜单，className根据 active 状态变化，控制显示/隐藏 */}
        <div className={active}>
          <ul className="navLists flex">
            {/* 导航列表项 */}
            <li className="navItem">
              <a href="#" className="navLink">
                首頁
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                推薦行程
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                協作行程
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                行程預訂
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                量身訂製
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                更多服務
              </a>
            </li>
            <li className="navItem">
              <a href="#" className="navLink">
                歷屆亮點
              </a>
            </li>
            {/* 登录/注册或用户信息及退出登录按钮 */}
            <li className="navItem">
              {currentUser ? (
                <div className="user-info">
                  <span className="user-email">{currentUser.email}</span>
                  <button className="btn logout-btn" onClick={handleLogout}>
                    退出登录
                  </button>
                </div>
              ) : (
                <div>
                  <button className="btn" onClick={() => setOpenAuth(true)}>
                    <Link to="/login">登入 / 註冊</Link>
                  </button>
                  {/* App组件用于展示登录/注册的界面，openAuth为true时显示 */}
                  <App open={openAuth} />
                </div>
              )}
            </li>
          </ul>
          {/* 关闭按钮，点击后隐藏导航栏（适用于移动端） */}
          <div onClick={removeNavbar} className="closeNavbar">
            <AiFillCloseCircle className="icon" />
          </div>
        </div>
        {/* 菜单切换按钮，点击后显示导航栏 */}
        <div onClick={showNav} className="toggleNavbar">
          <TbGridDots className="icon" />
        </div>
      </header>
    </section>
  );
};

export default Navbar;